module.exports = __webpack_public_path__ + "static/media/VISA.dff6871b.svg";